
export function initStatistics() {
    let items = $('.panel--statistics .count');
    
        items.each((index, element) => {
            let elementTop = $(element).offset().top;
            let elementBottom = elementTop + $(element).outerHeight();
    
            let viewportTop = $(window).scrollTop();
            let viewportBottom = viewportTop + $(window).height();
    
            let isInViewport = elementBottom > viewportTop && elementTop < viewportBottom;
            let endCount = $(element).data('to');
            if (isInViewport) {
                if(!$(element).hasClass('animated')){
                    $(element).addClass('animated');
                    $(element).jQuerySimpleCounter({ end: endCount} );
                }
    
            } else {
                $(element).removeClass('animated');
            }
        });

    
}
$.fn.jQuerySimpleCounter = function (options) {
    var settings = $.extend({
        start: 0,
        end: 100,
        easing: 'swing',
        duration: 2000,
        complete: ''
    }, options);

    var thisElement = $(this);

    $({ count: settings.start }).animate({ count: settings.end }, {
        duration: settings.duration,
        easing: settings.easing,
        step: function () {
            var mathCount = Math.ceil(this.count);
            thisElement.text(mathCount);
        },
        complete: settings.complete
    });
};

$(window).scroll(function () {
    initStatistics();
});

